<template>
  <div
    class="has-background-light is-border-top"
    id="lots"
    v-if="programContacts">
    <div class="is-padding has-background-white is-border-left is-border-right">
      <div class="title is-5 is-uppercase">
        Contact<span v-if="programContacts.length > 0">s</span> du programme
      </div>
    </div>
    <tabs
      :level="1"
      :is-fullwidth="true"
      :links="contactListLinks"
      :current-tab="contactListTab"
      @changeView="contactListTab = $event"
      mode="emitter"
      class="has-background-white is-border-left is-border-right is-border-top"></tabs>
    <div v-if="contactListTab == 'Contact'">
      <div class="is-padding-top-xsmall is-padding-bottom-xsmall is-padding-left is-padding-right is-border-top is-border-left is-border-right">
        <div class="columns is-variable is-2 is-vcentered">
          <div
            class="column is-narrow is-size-6 is-flex"
            :for="s.value"
            v-for="s in contactStatusList"
            :key="s.value">
            <span
              class="dot is-small is-self-centered is-margin-right-xxsmall"
              :style="{'background-color': tagColor(s.value)}"></span>
            <span>{{ s.label }}</span>
          </div>
        </div>
      </div>
      <table-controls-vue
        v-if=" programContacts.length"
        :has-sticky="true"
        :no-scroll-direction="true">
        <table class="table is-narrow is-fullwidth is-striped-v is-first-fixed-medium has-actionsontd">
          <thead class="has-cells-vcentered">
            <tr class="is-size-6">
              <th
                class="is-paddingless has-text-centered is-groupcols-1a"
                style="z-index:2;">
              </th>
              <th>
                Date de création
              </th>
              <th>
                Nom
              </th>
              <th>
                Prénom
              </th>
              <th>
                Email
              </th>
              <th>
                Téléphone
              </th>
              <th>
                Ville
              </th>
              <th>
                Origine
              </th>
            </tr>
          </thead>
          <tbody class="has-cells-vcentered">
            <tr
              v-for="(contact) in programContacts"
              :key="contact.pk"
              class="is-size-6"
              :id="'e' + contact.pk">
              <td class="has-text-centered is-paddingless">
                <span
                  class="dot tooltip is-tooltip-right"
                  :style="{'background-color': tagColor(contact.status)}"
                  :data-tooltip="contact.status | contactStatusLabel" />
              </td>
              <td>
                <span>
                  {{ contact.created_on | dtFormat('DD/MM/YYYY HH:mm') }}
                </span>
              </td>
              <td class="is-cell-hoverable">
                <router-link
                  :to="{name: 'ContactVue', params: {id: contact.pk}}"
                  class="fullLink"
                  :title="contact.last_name">
                  {{ contact.last_name }}
                </router-link>
              </td>
              <td class="is-cell-hoverable">
                <router-link
                  :to="{name: 'ContactVue', params: {id: contact.pk}}"
                  class="fullLink"
                  :title="contact.first_name">
                  {{ contact.first_name }}
                </router-link>
              </td>
              <td>
                <router-link
                  v-if="contact.email"
                  :to="{name: 'ContactVue', params: {id: contact.pk}}"
                  :title="contact.email">
                  {{ contact.email | truncate(35) }}
                </router-link>
              </td>
              <td>
                <phone-number
                  v-if="contact.phone"
                  :phone="contact.phone"></phone-number>
                <span v-else>N.C</span>
              </td>
              <td>
                <span v-if="contact.address && (contact.address.city || contact.address.zip_code)">
                  {{ contact.address.city || '-' }} <span v-if="contact.address.zip_code">({{ contact.address.zip_code }})</span>
                </span>
              </td>
              <td>
                <span v-if="contact.origin">
                  {{ contact.origin.name }}
                </span>
                <span v-else>-</span>
              </td>
            </tr>
          </tbody>
        </table>
      </table-controls-vue>
      <div v-show="!programContacts.length">
        <div class="is-padding">
          <h2 class="title is-5 has-text-weight-bold">
            Aucun contact disponible
          </h2>
        </div>
      </div>
      <pagination
        :loading="contactLoading"
        :current-page="contactCurrentPage"
        :total-page="contactTotalPage"
        @changePage="getContactsProgram($event)"></pagination>
    </div>
    <div v-else-if="contactListTab == 'Claim'">
      <div class="is-padding-top-xsmall is-padding-bottom-xsmall is-padding-left is-padding-right is-border-top is-border-left is-border-right">
        <div class="columns is-variable is-2 is-vcentered">
          <div
            class="column is-narrow is-size-6 is-flex"
            :for="s.value"
            v-for="s in activationStatus"
            :key="s.value">
            <span
              class="dot is-small is-self-centered is-margin-right-xxsmall"
              :class="s.color"></span>
            <span>{{ s.label }}</span>
          </div>
        </div>
      </div>
      <table-controls-vue
        v-if="programClaims.length"
        :has-sticky="true"
        :no-scroll-direction="true">
        <table class="table is-narrow is-fullwidth is-striped-v is-first-fixed-medium has-actionsontd">
          <thead class="has-cells-vcentered">
            <tr class="is-size-6">
              <th
                class="is-paddingless has-text-centered is-groupcols-1a"
                style="z-index:2;">
              </th>
              <th>
                Date de création
              </th>
              <th v-if="!isPromoteur">
                <span>
                  Promoteur
                </span>
              </th>
              <th v-if="isPromoteur">
                <span>
                  Société
                </span>
              </th>
              <th v-if="isAdmin || isManager">
                <span>Vendeur</span>
              </th>
              <th>
                <span>Contact</span>
              </th>
              <th>
                <span>Téléphone Contact</span>
              </th>
              <th>
                <span>Ville Contact</span>
              </th>
              <th>
                <span>Email Contact</span>
              </th>
            </tr>
          </thead>
          <tbody class="has-cells-vcentered">
            <tr
              v-for="(claim) in programClaims"
              :key="claim.pk"
              class="is-size-6"
              :id="'e' + claim.pk">
              <td class="has-text-centered is-paddingless">
                <span
                  class="dot tooltip is-tooltip-right"
                  :class="claim.status | dotClass"
                  :data-tooltip="optionStatus[claim.status].label" />
              </td>
              <td>
                <span>
                  {{ claim.created_on | dtFormat('DD/MM/YYYY HH:mm') }}
                </span>
              </td>
              <td
                v-if="!isPromoteur && isPromoteurDetailsActivated(claim)"
                class="is-cell-hoverable is-narrow">
                <router-link
                  :to="{name: 'PromoteurPresentation', params: {id: claim.promoteur.pk}}">
                  <span class="">{{ claim.promoteur.name }}</span>
                </router-link>
              </td>
              <td v-if="!isPromoteur && !isPromoteurDetailsActivated(claim)">
                {{ claim.promoteur.name }}
              </td>
              <td v-if="isPromoteur">
                {{ claim.user.account.name }}
              </td>
              <td
                v-if="isAdmin || isManager"
                class="is-cell-hoverable">
                <router-link
                  :to="{name: 'UserVue', params: {id: claim.user.pk}}"
                  class="fullLink">
                  {{ claim.user.last_name }} {{ claim.user.first_name }}
                </router-link>
              </td>
              <td
                :class="{'is-cell-hoverable' : claim.contact.account.pk === currentUser.account.pk}">
                <router-link
                  v-if="claim.contact.account.pk === currentUser.account.pk"
                  :to="{name: 'ContactVue', params: {id: claim.contact.pk}}"
                  class="fullLink">
                  {{ claim.contact.last_name }} {{ claim.contact.first_name }}
                </router-link>
                <template v-else>
                  {{ claim.contact.last_name }} {{ claim.contact.first_name }}
                </template>
              </td>
              <td>
                <phone-number :phone="claim.contact.phone" />
              </td>
              <td>
                <span v-if="claim.contact.address && (claim.contact.address.city || claim.contact.address.zip_code)">
                  {{ claim.contact.address.city || '-' }} <span v-if="claim.contact.address.zip_code">({{ claim.contact.address.zip_code }})</span>
                </span>
              </td>
              <td>
                <span v-if="claim.contact.email">{{ claim.contact.email }}</span>
              </td>
            </tr>
          </tbody>
        </table>
      </table-controls-vue>
      <div v-show="!programClaims.length">
        <div class="is-padding">
          <h2 class="title is-5 has-text-weight-bold">
            Aucune dénonciation disponible
          </h2>
        </div>
      </div>
      <pagination
        :loading="claimLoading"
        :current-page="claimCurrentPage"
        :total-page="claimTotalPage"
        @changePage="getProgramClaim($event)"></pagination>
    </div>
    <cta-to-promoteur
      v-if="!(isPromoteur && isAdmin)"
      class="is-sticky--bottom is-margin-left-auto is-margin-right is-margin-top"
      @clickOnCta="$emit('openModalTicket');"></cta-to-promoteur>
  </div>
</template>

<script>
import { DefaultValues, Sort } from '@/mixins'
import { mapGetters } from 'vuex'
import CtaToPromoteur from '@/components/utils/CtaToPromoteur'
import randomColor from 'randomcolor'

export default {
  name: 'ProgramContacts',
  filters: {
    dotClass (value) {
      const COLORS = {
        'approved': 'has-background-success',
        'pending': 'has-background-warning',
        'refused': 'has-background-danger'
      }
      return COLORS[value]
    }
  },
  components: {
    CtaToPromoteur
  },
  mixins: [DefaultValues, Sort],
  props: {
    program: {
      required: true
    }
  },
  data () {
    return {
      activationStatus: [
        { value: 'approved', label: 'Accepté', color: 'is-success' },
        { value: 'pending', label: 'En attente', color: 'is-warning' }
      ],
      sortBy: {},
      filters: {},
      contactListTab: 'Contact',
      contactLoading: true,
      contactTotalPage: 0,
      contactCurrentPage: 1,
      claimLoading: true,
      claimTotalPage: 0,
      claimCurrentPage: 1,
      programClaims: null,
      programContacts: null,
      totalContact: null,
      totalClaim: null
    }
  },
  computed: {
    ...mapGetters(['isPromoteur', 'isAdmin', 'isManager']),
    ...mapGetters({ storeAccounts: 'accounts' }),
    contactListLinks () {
      return [
        { link: 'Contact', label: `${this.totalContact} contact(s)` },
        { link: 'Claim', label: `${this.totalClaim} dénonciation(s)` }
      ]
    }
  },
  created () {
    this.getContactsProgram()
    this.getProgramClaim()
  },
  methods: {
    isPromoteurDetailsActivated (claim) {
      return this.storeAccounts.find(a => a.name === claim.promoteur.name).promoteur_details_activated
    },
    async getContactsProgram (page = null) {
      this.contactLoading = true
      let params = {
        per_page: 50,
        page: page
      }
      try {
        let { data } = await this.$api.get(`/programs/${this.$route.params.id}/contacts`, params)
        this.contactLoading = false
        this.programContacts = data.items
        this.contactTotalPage = data.pages
        this.currentPage = data.page
        this.totalContact = data.count
      } catch (e) {
        this.contactLoading = false
      }
    },
    async getProgramClaim (page = null) {
      this.claimLoading = true
      let params = {
        sort: 'created_on:desc',
        status: ['pending', 'approved'],
        program: this.program.pk,
        per_page: 50,
        page: page
      }
      try {
        let { data } = await this.$api.get(this.$resources.CLAIM, params)
        this.claimLoading = false
        this.programClaims = data.items
        this.claimTotalPage = data.pages
        this.claimCurrentPage = data.page
        this.totalClaim = data.count
      } catch (e) {
        this.claimLoading = false
      }
    },
    tagColor (value, hue = 'blue') {
      let color = randomColor({
        seed: value,
        hue
      })
      return color
    }
  }
}
</script>
